import 'dayjs/locale/en';
import 'dayjs/locale/vi';
import 'dayjs/locale/fr';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/ar-sa';
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider as Provider} from '@mui/x-date-pickers/LocalizationProvider';
import {Info, Settings} from 'luxon';
import {ReactNode} from 'react';

import {useTranslate} from './use-locales';

// ----------------------------------------------------------------------

type Props = {
  children: ReactNode;
};

export function LocalizationProvider({children}: Props) {
  const {currentLang} = useTranslate();

  Settings.defaultWeekSettings = {
    // Sunday = 7, Monday = 1.
    firstDay: 1,
    // Makes sure we don't lose the other information from `defaultWeekSettings`
    minimalDays: Info.getMinimumDaysInFirstWeek(),
    weekend: Info.getWeekendWeekdays(),
  };
  Settings.defaultLocale = 'fr';

  return (
    <Provider dateAdapter={AdapterDayjs} adapterLocale={currentLang.adapterLocale}>
      {children}
    </Provider>
  );
}
